"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItemIcon = exports.NotificationIconMap = exports.useNotificationIconBg = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const ActivityIcons_1 = require("../../../features/ActivityFeedV2/components/ActivityIcons");
exports.testIds = {
    icon: 'notification_item-icon',
};
const useNotificationIconBg = () => {
    const bgMap = (0, ActivityIcons_1.useIconBg)();
    return {
        [notification_center_models_1.NotificationType.DeviationRisk]: bgMap.deviationRisk,
        [notification_center_models_1.NotificationType.Deviation]: bgMap.deviation,
        [notification_center_models_1.NotificationType.Reassurance]: bgMap.reassurance,
        [notification_center_models_1.NotificationType.Approval]: bgMap.approval,
        [notification_center_models_1.NotificationType.OpenTask]: bgMap.approval,
        [notification_center_models_1.NotificationType.Message]: bgMap.update,
        [notification_center_models_1.NotificationType.Update]: bgMap.update,
        [notification_center_models_1.NotificationType.Activity]: bgMap.update,
    };
};
exports.useNotificationIconBg = useNotificationIconBg;
exports.NotificationIconMap = {
    [notification_center_models_1.NotificationType.DeviationRisk]: ActivityIcons_1.DeviationRiskInsightIcon,
    [notification_center_models_1.NotificationType.Deviation]: ActivityIcons_1.IconMap.deviation,
    [notification_center_models_1.NotificationType.Update]: ActivityIcons_1.IconMap.update,
    [notification_center_models_1.NotificationType.Reassurance]: ActivityIcons_1.ReassuranceInsightIcon,
    [notification_center_models_1.NotificationType.Approval]: ActivityIcons_1.IconMap.approval,
    [notification_center_models_1.NotificationType.OpenTask]: ActivityIcons_1.IconMap.openTasks,
    [notification_center_models_1.NotificationType.Message]: ActivityIcons_1.IconMap.message,
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => {
    const bgMap = (0, exports.useNotificationIconBg)();
    return {
        iconBox: ({ type }) => ({
            height: 74,
            width: 32,
            flex: 'none',
            background: bgMap[type] || theme.palette.grey[300],
            borderRadius: 4,
            alignSelf: 'stretch',
            display: 'flex',
            marginRight: 12,
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'center',
        }),
        dot: {
            position: 'absolute',
            height: 12,
            width: 12,
            background: theme.palette.header.background,
            borderRadius: '50%',
            top: -4,
            left: -4,
            border: `2px solid ${theme.palette.background.paper}`,
        },
    };
});
const NotificationItemIcon = ({ type, status }) => {
    const classes = useStyles({ type });
    const Icon = exports.NotificationIconMap[type] || exports.NotificationIconMap[notification_center_models_1.NotificationType.Update];
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { className: classes.iconBox, "data-testid": exports.testIds.icon, children: [status === notification_center_models_1.UserNotificationStatus.New && (0, jsx_runtime_1.jsx)("span", { className: classes.dot }), Icon && (0, jsx_runtime_1.jsx)(Icon, {})] }));
};
exports.NotificationItemIcon = NotificationItemIcon;
//# sourceMappingURL=NotificationItemIcon.js.map